export function cleanObject<T>(
  item: Partial<T>,
  nullFn: (val: any) => boolean = (val: any) => val == null
) {
  const values = { ...item };
  Object.keys(values).forEach((key) => {
    if (nullFn(values[key as keyof T])) {
      delete values[key as keyof T];
    }
  });
  return values as T;
}
